import React from 'react';
import { useContact } from '../contexts/ContactContext';

// The admin console writes this when the admin leaves the note blank.
const DEFAULT_REASON = 'Admin cancellation';

/** The admin's note to show, or null when they didn't write one. */
export function adminCancelNote(offer) {
  const reason = typeof offer?.cancelReason === 'string' ? offer.cancelReason.trim() : '';
  return reason && reason !== DEFAULT_REASON ? reason : null;
}

export function isAdminCancelled(offer) {
  return offer?.status === 'cancelled' && offer?.cancelledBy === 'admin';
}

/**
 * Top-of-page notice on an offer an admin cancelled (trade or purchase).
 *
 * Until 2026-10-12 neither offer page had any cancelled state: the history
 * ended at the acceptance, so tapping "Trade Cancelled by Admin" landed on a
 * page whose last word was "Accepted!". The admin's note (cancelReason) was
 * only in the email and the notification text.
 */
const AdminCancelledBanner = ({ offer, kind = 'trade' }) => {
  const { openContact } = useContact();
  if (!isAdminCancelled(offer)) return null;
  const note = adminCancelNote(offer);
  return (
    <div
      role="status"
      style={{
        maxWidth: '600px', width: '100%', boxSizing: 'border-box', margin: '0 auto 1rem auto',
        padding: '14px 16px', borderRadius: '12px', backgroundColor: '#fef2f2',
        border: '1px solid #fecaca', fontFamily: 'Nunito, sans-serif', textAlign: 'left',
      }}
    >
      <p style={{ margin: 0, fontWeight: 800, color: '#991b1b', fontSize: '1rem' }}>
        This {kind} was cancelled by PedalxChange
      </p>
      {note && (
        <p style={{ margin: '6px 0 0 0', color: '#4A5759', fontSize: '0.95rem', lineHeight: 1.45 }}>
          <strong>Note from PedalxChange:</strong> {note}
        </p>
      )}
      <p style={{ margin: '6px 0 0 0', color: '#6b7280', fontSize: '0.85rem' }}>
        Questions?{' '}
        <button
          type="button"
          onClick={() => openContact({ subject: `Cancelled ${kind}` })}
          style={{ background: 'none', border: 'none', padding: 0, color: '#2563eb', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit', fontSize: 'inherit' }}
        >
          Contact us
        </button>
      </p>
    </div>
  );
};

export default AdminCancelledBanner;
